import {userHovercardPath} from '@github-ui/paths'
import {Link} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import {VALUES} from '../constants/values'
import type {IssueBodyHeaderAuthor$key} from './__generated__/IssueBodyHeaderAuthor.graphql'
import styles from './IssueBodyHeaderAuthor.module.css'

export function IssueBodyHeaderAuthor({author}: {author: IssueBodyHeaderAuthor$key | null; showLogin?: boolean}) {
  const data = useFragment(
    graphql`
      fragment IssueBodyHeaderAuthor on Actor {
        login
        profileUrl
      }
    `,
    author,
  )

  const {login, profileUrl} = data || VALUES.ghost
  return (
    <Link
      href={profileUrl || undefined}
      data-hovercard-url={profileUrl && userHovercardPath({owner: login})}
      data-testid="issue-body-header-author"
      sx={{
        ':hover': {
          textDecoration: profileUrl ? 'underline' : 'none',
        },
      }}
      className={styles.authorLoginLink}
    >
      {login}
    </Link>
  )
}

try{ IssueBodyHeaderAuthor.displayName ||= 'IssueBodyHeaderAuthor' } catch {}